import Image from 'next/image';
import cn from 'classnames';
import AnimCard1 from '@/components/AnimCards/AnimCard1';
import AnimCard2 from '@/components/AnimCards/AnimCard2';
import AnimCard3 from '@/components/AnimCards/AnimCard3';
import AnimCard4 from '@/components/AnimCards/AnimCard4';
import AnimCard5 from '@/components/AnimCards/AnimCard5';
import AnimCard6 from '@/components/AnimCards/AnimCard6';
import AnimCard7 from '@/components/AnimCards/AnimCard7';

import styles from 'styles/pages/empresas.module.scss';

const Carta = ({ image, title, text, wrapperTitle, animCard = 1 }) => {
  const AnimCard1Wrapper = () => {
    return <AnimCard1 />;
  };
  const AnimCard2Wrapper = () => {
    return <AnimCard2 />;
  };
  const AnimCard3Wrapper = () => {
    return <AnimCard3 />;
  };
  const AnimCard4Wrapper = () => {
    return <AnimCard4 />;
  };
  const AnimCard5Wrapper = () => {
    return <AnimCard5 />;
  };
  const AnimCard6Wrapper = () => {
    return <AnimCard6 />;
  };
  const AnimCard7Wrapper = () => {
    return <AnimCard7 />;
  };

  return (
    <div
      className={cn(
        'relative w-[31.6rem] rounded-[3rem] pt-20 pb-45 px-45 flex flex-col items-start min-h-[41rem]',
        styles.shadow,
        styles.card
      )}
    >
      <div className="relative w-[22.8rem] h-[19.3rem] mb-20">
        {animCard === 1 && AnimCard1Wrapper()}
        {animCard === 2 && AnimCard2Wrapper()}
        {animCard === 3 && AnimCard3Wrapper()}
        {animCard === 4 && AnimCard4Wrapper()}
        {animCard === 5 && AnimCard5Wrapper()}
        {animCard === 6 && AnimCard6Wrapper()}
        {animCard === 7 && AnimCard7Wrapper()}
      </div>
      <div className={cn('mb-8', wrapperTitle)}>
        <h3 className="title-h5 text-cyan-dark">{title}</h3>
      </div>
      <div className="min-h-[8.5rem]">
        <p className="p2 text-black opacity-60">{text}</p>
      </div>
    </div>
  );
};
export default Carta;
